import React, { useEffect, useState, useRef } from "react";
import jsPDF from "jspdf";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";
import { Printer } from "lucide-react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import ExcelExport from "./ExcelExport";
import logo from "./../../images/logo1.jpeg";
import bma from "./../../images/bma.jpeg";
import godrej from "./../../images/combinedimage2.png";
import voltas from "./../../images/voltas2.png";
import kent from "./../../images/kent.jpeg";
import toWords from "number-to-words";
import signatoryImage from "./../../images/signatory.jpeg";
export default function InvoicePage() {
  const { id } = useParams();
  const invoiceRef = useRef();
  const [quotation, setQuotation] = useState(null);
  const currentDate = new Date().toLocaleDateString("en-IN", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const currentTime = new Date().toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
  const formatCurrencyInWords = (amount) => {
    // Convert the amount to words
    let words = toWords.toWords(amount);

    // Capitalize the first letter of each word
    words = words.replace(/\b\w/g, (char) => char.toUpperCase());

    // Replace Western numbering terms with Indian equivalents
    words = words
      .replace(/\bMillion\b/g, "Lakh") // 1,000,000 becomes 1 Lakh
      .replace(/\bBillion\b/g, "Crore") // 1,000,000,000 becomes 1 Crore
      .replace(/\bTrillion\b/g, "Arab"); // 1,000,000,000,000 becomes 1 Arab

    return `${words} Rupees`;
  };
  const wrapText = (text, maxLength) => {
    const words = text.split(" ");
    const lines = [];
    let currentLine = "";

    words.forEach((word) => {
      if (currentLine.length + word.length + 1 > maxLength) {
        lines.push(currentLine);
        currentLine = word;
      } else {
        currentLine += currentLine ? " " + word : word;
      }
    });

    if (currentLine) lines.push(currentLine); // Add any remaining text as the last line
    return lines;
  };
  // Fetch quotation data from API
  useEffect(() => {
    const fetchQuotationData = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await fetch(`${API_BASE_URL}/api/quotations/${id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`, // Replace with your actual token if necessary
          },
        });

        if (response.ok) {
          const data = await response.json();
          setQuotation(data);
        } else {
          console.error("Failed to fetch quotation data");
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchQuotationData();
  }, []);

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    const options = {
      margin: 1,
      filename: `quotation_${quotation?.quotationIdNumber}.pdf`, // 
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    };
    html2pdf().from(invoiceRef.current).set(options).save(); // Generates the PDF and triggers download
  };
  const formatDate = (date) => {
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0"); // Ensure two digits for day
    const month = String(d.getMonth() + 1).padStart(2, "0"); // Get month and ensure two digits (months are 0-indexed)
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  };
  if (!quotation) {
    return <div>Loading...</div>; // Show loading message while data is being fetched
  }
  const totalgstamount = quotation.totalAfterGST - quotation.totalAfterDiscount;

  return (
    <div className="min-h-screen p-8 print:p-0">
      <div
        // shadow-md
        className="mx-auto max-w-4xl bg-white rounded-lg"
        ref={invoiceRef}
      >
        {/* Card Header */}
        <div className="flex flex-row items-center justify-between p-4 relative">
  {/* Logo on the left side */}
  <div className="absolute left-4 top-4">
    <img
      src={bma}
      alt="Company Logo"
      className="h-12" // Adjust the size as needed
    />
  </div>

  {/* Centered Quotation Text */}
  <div className="flex-grow flex justify-center">
    <h1 className="text-2xl font-bold text-primary">Quotation</h1>
  </div>

  {/* Logos on the right side */}
  <div className="absolute right-4 top-4 flex space-x-4">
    <img
      src={godrej}
      alt="Godrej Logo"
      className="h-14 w-auto" // Adjust the size as needed
    />
    {/* <img
      src={voltas}
      alt="Voltas Logo"
      className="h-6" // Adjust the size as needed
    />
    <img
      src={kent}
      alt="Kent Logo"
      className="h-6" // Adjust the size as needed
    /> */}
  </div>

  {/* Button to download PDF, positioned in the left corner */}
  <div className="absolute left-4 top-4">
    <button
      onClick={handlePrint}
      className="flex items-center border border-gray-300 rounded-md px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 print:hidden"
    >
      <Printer className="mr-2 h-4 w-4" />
      Download PDF
    </button>
  </div>

  {/* <ExcelExport quotation={quotation} /> */}
</div>


        {/* Card Content */}
        <div className="space-y-6 p-6" style={{ marginTop: "-30px" }}>
          

          {/* Invoice Details */}
          <div
            className="grid grid-cols-2 gap-[10rem] "
            style={{ marginTop: "2px" }}
          >
            <div className="space-y-0.5 text-sm">
              <div className="space-y-1">
              <h2 className="text-1xl font-bold text-black">
                Barnala Marketing Agencies
              </h2>
                <p>3367 , Ferozepur Road, Ludhiana</p>
                <p>
                  <span className="font-semibold">Ph :</span> 0161 2429245
                  <span className="font-semibold"> Email :</span> Rajiv@barnala.biz
                  
                </p>
                <span className="font-semibold"> GST :</span> 03ACUPS6200Q1Z0
                
              </div>
            </div>
            <div className="space-y-1 text-sm">
            
              <div className="space-y-0.5 text-sm">
                {/* <h3 className="font-semibold text-black">To:</h3> */}
                <br />
                <p className="font-semibold">To : {quotation.client.clientName}</p>
                <p className="font-semibold">{quotation.client.clientAddress}</p>
                <span className="font-semibold text-black">Date:</span>
                <span>{formatDate(quotation.createdAt)}</span>
                <span className="font-semibold text-black ml-4">
                  Quotation#:
                </span>
                <span>{quotation.quotationIdNumber}</span>
              </div>
            </div>
          </div>

          {/* Invoice Items Table */}
          <div className="mt-6">
            <table className="w-full table-auto border-collapse">
              <thead>
                <tr className="border-b">
                  <th className="py-1 text-left font-semibold text-black">
                    Area
                  </th>
                  <th className="py-1 text-left font-semibold text-black">
                    Category
                  </th>
                  <th className="py-1 text-left font-semibold text-black">
                    Item Name
                  </th>
                  <th className="py-1 text-left font-semibold text-black">
                    Specification
                  </th>
                  <th className="py-1 text-left font-semibold text-black">
                    Image
                  </th>
                  <th className="py-1 text-right font-semibold text-black">
                    Quantity
                  </th>
                  <th className="py-1 text-right font-semibold text-black">
                    Price
                  </th>
                  <th className="py-1 text-right font-semibold text-black">
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {quotation.items.map((item) => (
                  <tr key={item._id} className="border-b">
                    <td className="py-1">{item.area}</td>
                    <td className="py-1">{item.category}</td>
                    <td className="py-1">
                      {item.itemName &&
                        wrapText(item.itemName, 20).map((line, index) => (
                          <div key={index}>{line}</div>
                        ))}
                    </td>
                    <td className="py-2">
                      {item.specification &&
                        wrapText(item.specification, 40).map((line, index) => (
                          <div key={index}>{line}</div>
                        ))}
                    </td>

                    <td className="py-1 text-center">
                      {item.itemImage ? (
                        <img
                          src={item.itemImage}
                          alt={item.itemName}
                          className="w-12 h-12 object-contain border rounded"
                        />
                      ) : (
                        <span className="text-sm text-gray-500">No Image</span>
                      )}
                    </td>
                    <td className="py-1 text-center">{item.quantity}</td>
                    <td className="py-1 text-center">{Math.round(item.price)}</td>
                    <td className="py-1 text-center">{Math.round(item.total)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Totals */}
          <div className="mt-4 flex justify-between">
            <div className="space-y-2 w-[40%]">
              {/* Conditionally render <br /> tags based on discount */}
              {quotation.discount !== 0 ? (
                <>
                  <br />
                  <br />
                  <br />
                  <br />
                </>
              ) : (
                <>
                  <br />
                  <br />
                </>
              )}

              {/* Display Total in Words with some space below */}
              <div className="flex flex-col mt-6">
                <span className="font-semibold text-black">
                  Total in Words:
                </span>
                <span>{formatCurrencyInWords(quotation.totalAfterGST)}</span>
              </div>
            </div>

            <div className="space-y-2 w-[40%]">
              <div className="flex justify-between gap-6">
                <span className="font-semibold text-black">Subtotal:</span>
                <span>₹ {Math.round(quotation.totalBeforeDiscount)}</span>
              </div>

              <div>
                {/* Only show discount and total after discount if discount is greater than 0 */}
                {quotation.discount !== 0 && (
                  <>
                    <div className="flex justify-between gap-6">
                      <span className="font-semibold text-black">
                        Discount:
                      </span>
                      <span>{Math.round(quotation.discount)}%</span>
                    </div>
                    <div className="flex justify-between gap-6">
                      <span className="font-semibold text-black">
                        Total After Discount:
                      </span>
                      <span>₹ {Math.round(quotation.totalAfterDiscount)}</span>
                    </div>
                  </>
                )}
              </div>

              <div className="flex justify-between gap-6">
                <span className="font-semibold text-black">
                  GST {quotation.gstPercentage}% (or Incl in items)
                </span>
                <span>₹ {Math.round(totalgstamount)}</span>
              </div>
              <div className="flex justify-between gap-6 border-t pt-2">
                <span className="text font-bold text-black">
                  Total (Inc. GST):
                </span>
                <span className="text font-bold">
                  ₹ {Math.round(quotation.totalAfterGST)}
                </span>
              </div>
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="mt-3 flex justify-between">
            {/* Left Side: Terms & Conditions */}
            <div className="w-2/3">
              <h3 className="text-sm font-bold text-black">
              General Terms & Conditions
              </h3>
              
              <ul className=" mt-0 text-xs">
                <li>
                  <span>Payment Terms:</span> 100% Along with order
                </li>
                <li>
                  <span>Delivery Period:</span> 1-8 weeks depending upon the
                  model
                </li>
                <li>
                  <span>Cartage & Unloading:</span> Extra . All surplus material & Cartons remain our property & lifted back after installation
                </li>
                
                <li>
                  <span>Validity:</span> 4 Weeks for Godrej & Furniture items . 1 Week for Cooling products  
                </li>
                <li>
                  <span>Warranty period:</span> 1 Year as per Company Terms & Conditions Surplus Materia
                </li>
                <li>
                  <span>Surplus Material:</span> All surplus material,
                  consumables & Cartons will remain our property & lifted back
                </li>

                
              </ul>
              {/* <br /> */}
              <h3 className="text-sm font-bold text-black">
              For Air Conditioners & Water Coolers
              </h3>
              
              <ul className="text-xs">
              <p className="text-xs">Instllation of Water cooler and AC Drain in your plumber scope</p>
                <li>
                  <span>Delivery Period:</span> Ex Stock - 1 Week
                </li>
                <p>All Grille cutting , glass cutting , wall cutting , Wooden frame Extra</p>
                <p>Electrical Point will be required from customer end with in 1 meter of of installation point of unit .</p>
                <p>Warranty & Service for by Authorised Service Centers as per company terms and conditions  .</p>

                
              </ul>
            </div>

            {/* Right Side: Authorized Signatory */}
            <div className="w-[25%] text-right mt-[8rem]">
  <h4 className="mt-4 flex justify-center font-semibold text-sm">
    For Barnala Marketing Agencies
  </h4>
  <h4 className="mt-4 text-right font-semibold text-sm">
    <div>{quotation?.createdBy?.fullName}</div>
    <div>{quotation?.createdBy?.phone}</div>
  </h4>
</div>

          </div>
        </div>

      </div>

      {/* Global Styles for Print */}
      <style jsx global>{`
        @media print {
          @page {
            margin: 5mm;
          }
          body {
            font-size: 10pt;
            line-height: 1.4;
            print-color-adjust: exact;
          }
          .print\\:hidden {
            display: none !important;
          }
          .table-auto {
            width: 100%;
            border-collapse: collapse;
          }
          .table-auto th,
          .table-auto td {
            border: 1px solid #ccc;
            padding: 4px;
          }
          .table-auto th {
            text-align: left;
          }
          .absolute {
            position: absolute;
          }
          .right-4 {
            right: 1rem;
          }
          .top-4 {
            top: 1rem;
          }
          .print\\:block {
            display: block !important;
          }
          .print\\:hidden {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
}

// <td className="py-2">

//                      {item.specification.split("\n").map((line, index) => (
//                        <div key={index}>{line}</div>
//                      ))}
//                    </td>

// const downloadPDF = () => {
//   const input = invoiceRef.current;

//   html2canvas(input, {
//     scale: 2, // Optional: increases quality of the rendered canvas
//   }).then((canvas) => {
//     const imgData = canvas.toDataURL("image/png");

//     // Create jsPDF instance and add the canvas image as PDF content
//     const doc = new jsPDF("portrait", "px", "a4");
//     const imgWidth = 400; // A4 width in mm
//     const imgHeight = (canvas.height * imgWidth) / canvas.width; // Adjust height to match width
//     doc.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight); // Add image to PDF
//     doc.save("invoice.pdf"); // Download the PDF
//   });
// };

// const downloadPDF = () => {
//   const input = invoiceRef.current;

//   // Increase canvas quality by adjusting the scale and other parameters
//   html2canvas(input, {
//     scale: 4, // Increase this scale for better quality
//     logging: true, // Optionally log for debugging
//     useCORS: true, // Make sure CORS settings are handled for external images
//     allowTaint: false, // Ensure canvas is clean
//   }).then((canvas) => {
//     const imgData = canvas.toDataURL("image/png");

//     // Create jsPDF instance with better options for A4 size and high quality
//     const doc = new jsPDF("portrait", "mm", "a4");

//     const imgWidth = doc.internal.pageSize.getWidth() - 20; // A4 width minus margin
//     const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

//     // Add the image to the PDF, with proper scaling and positioning
//     doc.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);

//     // Get the PDF as a Blob
//     const pdfBlob = doc.output("blob");

//     // Prepare FormData for uploading to the backend
//     const formData = new FormData();
//     formData.append("quotationPdf", pdfBlob, "invoice.pdf");

//     // Define the API URL to upload the PDF
//     const apiUrl = `http://localhost:5000/api/quotations/${id}/upload-pdf`;
//     const token = localStorage.getItem("token");

//     // Upload the PDF to the server
//     fetch(apiUrl, {
//       method: "PUT",
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//       body: formData,
//     })
//       .then((response) => {
//         if (response.ok) {
//           console.log("PDF uploaded successfully.");
//         } else {
//           console.error("Failed to upload PDF.");
//         }
//       })
//       .catch((error) => {
//         console.error("Error uploading PDF:", error);
//       });

//     // Save the PDF locally after uploading
//     doc.save("invoice.pdf"); // Trigger the download of the PDF
//   });
// };

// import React, { useRef } from "react";
// import jsPDF from "jspdf";

// const InvoicePage = () => {
//   const invoiceRef = useRef();

//   const downloadPDF = () => {
//     const doc = new jsPDF({
//       orientation: "portrait", // Landscape mode to utilize width
//       unit: "px", // Use pixels for dimensions
//       format: [1152, 1728], // ARCH A dimensions
//     });

//     doc.html(invoiceRef.current, {
//       callback: (doc) => {
//         doc.save("invoice.pdf");
//       },
//       x: 20, // Add some padding on the X-axis
//       y: 20, // Add some padding on the Y-axis
//     });
//   };

//   return (
//     <div>
//       {/* Invoice Content */}
//       <div
//         ref={invoiceRef}
//         style={{
//           padding: "20px",
//           fontFamily: "Arial",
//           width: "1100px", // Adjust the width to fit within ARCH A
//         }}
//       >
//         <h1 style={{ textAlign: "center", color: "#0073e6" }}>SALES INVOICE</h1>
//         {/* Company and Invoice Details */}
//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <div>
//             <p><strong>Your Sales Company Name</strong></p>
//             <p>Street Address</p>
//             <p>City, ST ZIP Code</p>
//             <p>Phone: 123-456-7890</p>
//           </div>
//           <div>
//             <p><strong>Date:</strong> 01/01/2024</p>
//             <p><strong>Invoice #:</strong> 123456</p>
//           </div>
//         </div>
//         <hr />
//         {/* Billing and Shipping Info */}
//         <div style={{ display: "flex", justifyContent: "space-between" }}>
//           <div>
//             <p><strong>Bill To:</strong></p>
//             <p>Client Name</p>
//             <p>Client Address</p>
//           </div>
//           <div>
//             <p><strong>Ship To:</strong></p>
//             <p>Client Name</p>
//             <p>Client Address</p>
//           </div>
//         </div>
//         {/* Table Section */}
//         <table
//           style={{
//             width: "100%",
//             borderCollapse: "collapse",
//             marginTop: "20px",
//             fontSize: "14px", // Reduced font size to fit more details
//           }}
//         >
//           <thead>
//             <tr>
//               <th style={styles.th}>SR#</th>
//               <th style={styles.th}>Description</th>
//               <th style={styles.th}>Quantity</th>
//               <th style={styles.th}>Unit Price</th>
//               <th style={styles.th}>Discount</th>
//               <th style={styles.th}>Line Total</th>
//             </tr>
//           </thead>
//           <tbody>
//             {Array.from({ length: 15 }).map((_, index) => (
//               <tr key={index}>
//                 <td style={styles.td}>{index + 1}</td>
//                 <td style={styles.td}>Product Description</td>
//                 <td style={styles.td}>1</td>
//                 <td style={styles.td}>$100.00</td>
//                 <td style={styles.td}>0%</td>
//                 <td style={styles.td}>$100.00</td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//         {/* Totals Section */}
//         <div style={{ marginTop: "20px", textAlign: "right" }}>
//           <p>Subtotal: $1500.00</p>
//           <p>PST (8%): $120.00</p>
//           <p>GST (6%): $90.00</p>
//           <p><strong>Total Payable: $1710.00</strong></p>
//         </div>
//         <p style={{ marginTop: "20px", fontSize: "12px" }}>
//           Thank you for your business!
//         </p>
//       </div>
//       {/* Download Button */}
//       <button
//         onClick={downloadPDF}
//         style={{
//           marginTop: "20px",
//           padding: "10px 20px",
//           backgroundColor: "#0073e6",
//           color: "#fff",
//           border: "none",
//           cursor: "pointer",
//         }}
//       >
//         Download PDF
//       </button>
//     </div>
//   );
// };

// const styles = {
//   th: {
//     border: "1px solid #ddd",
//     padding: "8px",
//     textAlign: "left",
//     backgroundColor: "#f2f2f2",
//   },
//   td: {
//     border: "1px solid #ddd",
//     padding: "8px",
//     textAlign: "left",
//   },
// };

// export default InvoicePage;
